import {
    Box,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    Stack,
    Button,
    Heading,
    Text
} from '@chakra-ui/react'
import * as yup from 'yup'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'

import CustomLink from '@/components/CustomLink'
import { useAlertService } from '@/shared/lib/useAlertService'
import { AuthService } from '@/shared/api/rest/services/auth.service'

const RESET_MESSAGE = `Please note the reset email can 
take a few minutes.  Don't forget to check your spam folder 😊`

const signupSchema = yup.object({
    email: yup.string().required()
})

export default function PasswordReset() {
    const alertService = useAlertService()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)

    const forgotPassword = async ({ variables }: { variables: { email: string } }) => {
        setLoading(true)
        try {
            await AuthService.forgotPassword(variables.email)
            alertService.success(RESET_MESSAGE, 'Password reset successfully')
            navigate('/')
        } catch (error) {
            alertService.error(error instanceof Error ? error.message : 'Error', 'Error')
        } finally {
            setLoading(false)
        }
    }

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(signupSchema),
        defaultValues: {
            email: ''
        }
    })

    return (
        <>
            <Stack textAlign={'center'}>
                <Heading fontSize={'2xl'}>Reset your password</Heading>
                <Text fontSize={{ base: 'sm', sm: 'md' }} color={'gray.600'}>
                    You&apos;ll get an email with a reset link
                </Text>
            </Stack>

            <Box rounded={'lg'} bg={'white'} boxShadow={'lg'} p={8}>
                <Stack spacing={4}>
                    <FormControl isInvalid={Boolean(errors.email)} isRequired>
                        <FormLabel>Email</FormLabel>
                        <Input type="text" id="email" {...register('email')} />
                        <FormErrorMessage>
                            {errors.email && errors.email.message}
                        </FormErrorMessage>
                    </FormControl>
                    <Stack spacing={10} pt={2}>
                        <Button
                            type="submit"
                            loadingText="Submitting"
                            size="lg"
                            isLoading={loading}
                            onClick={handleSubmit((formValue) => {
                                forgotPassword({
                                    variables: {
                                        email: formValue.email
                                    }
                                })
                            })}
                        >
                            Submit
                        </Button>
                    </Stack>
                    <Stack pt={6}>
                        <Text align={'center'}>
                            <CustomLink href="/account/signup">Return to Home</CustomLink>
                        </Text>
                    </Stack>
                </Stack>
            </Box>
        </>
    )
}
